import React, { useCallback } from 'react';

import { useIntl } from 'react-intl-next';

import { useFlags } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import flagMessages from '../../../../messages';

export enum StoreErrorFlagId {
	CONVERSATION_FORBIDDEN = 'conversationForbidden',
}

export const useShowStoreErrorFlag = (): (flagId: StoreErrorFlagId) => void => {
	const { showFlag: showFlagFromFlags } = useFlags();
	const { formatMessage } = useIntl();

	const showFlag = useCallback(
		(flagId: StoreErrorFlagId) => {
			switch (flagId) {
				case StoreErrorFlagId.CONVERSATION_FORBIDDEN:
					showFlagFromFlags({
						id: 'conversation-assistant.conversation-forbidden',
						title: formatMessage(flagMessages.conversationForbiddenTitle),
						description: formatMessage(flagMessages.conversationForbiddenDescription),
						icon: <StatusErrorIcon color={token('color.icon.danger')} label="" />,
						isAutoDismiss: true,
					});
					break;
			}
		},
		[showFlagFromFlags, formatMessage],
	);

	return showFlag;
};
